<form>
    <h2 class="margin">¡Contraseña actualizada!</h2>
    <p style="padding-bottom: 10px">Ahora inicia sesion con tu nueva contraseña</p>
    <button mat-raised-button color="accent" [routerLink]="['/auth/login']">Entendido</button>
</form>